"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOSIOAuthUser = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const bs58 = __importStar(require("bs58"));
const eosjs_1 = require("eosjs");
const text_encoding_1 = require("text-encoding");
const RIPEMD160 = require('eosjs/dist/ripemd').RIPEMD160.hash; // tslint:disable-line
const PlatformChecker_1 = require("./PlatformChecker");
const UALEOSIOAuthError_1 = require("./UALEOSIOAuthError");
class EOSIOAuthUser extends universal_authenticator_library_1.User {
    constructor(chain, accountName, options) {
        super();
        this.chain = chain;
        this.accountName = accountName;
        this.options = options;
        this.api = null;
        this.rpc = null;
        if (typeof (TextEncoder) !== 'undefined') {
            this.textEncoder = TextEncoder;
            this.textDecoder = TextDecoder;
        }
        else {
            this.textEncoder = text_encoding_1.TextEncoder;
            this.textDecoder = text_encoding_1.TextDecoder;
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const platformChecker = new PlatformChecker_1.PlatformChecker(this.options);
            const SignatureProvider = platformChecker.getSupportedSignatureProvider();
            const declaredDomain = platformChecker.declaredDomain;
            const returnUrl = yield platformChecker.getReturnUrl();
            this.signatureProvider = new SignatureProvider(Object.assign(Object.assign({ declaredDomain,
                returnUrl }, (this.options && this.options.securityExclusions && { securityExclusions: this.options.securityExclusions })), { options: this.options }));
            const rpcEndpoint = this.chain.rpcEndpoints[0];
            const rpcEndpointString = this.buildRpcEndpoint(rpcEndpoint);
            this.rpc = new eosjs_1.JsonRpc(rpcEndpointString);
            this.api = new eosjs_1.Api({
                rpc: this.rpc,
                signatureProvider: this.signatureProvider,
                textEncoder: new this.textEncoder(),
                textDecoder: new this.textDecoder(),
            });
        });
    }
    signTransaction(transaction, { broadcast = true, blocksBehind = 3, expireSeconds = 30 }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.throwIfNotInitialized();
                const completedTransaction = this.api && (yield this.api.transact(transaction, { broadcast, blocksBehind, expireSeconds }));
                return this.returnEosjsTransaction(broadcast, completedTransaction);
            }
            catch (e) {
                const message = 'Unable to sign transaction';
                const type = universal_authenticator_library_1.UALErrorType.Signing;
                const cause = e;
                throw new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
            }
        });
    }
    signArbitrary() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new UALEOSIOAuthError_1.UALEOSIOAuthError('EOSIO Reference Authenticator does not currently support signArbitrary', universal_authenticator_library_1.UALErrorType.Unsupported, null);
        });
    }
    verifyKeyOwnership(_) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new UALEOSIOAuthError_1.UALEOSIOAuthError('EOSIO Reference Authenticator does not currently support verifyKeyOwnership', universal_authenticator_library_1.UALErrorType.Unsupported, null);
        });
    }
    getAccountName() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.accountName;
        });
    }
    getChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.chain.chainId;
        });
    }
    getKeys() {
        return __awaiter(this, void 0, void 0, function* () {
            const keys = yield this.signatureProvider.getAvailableKeys();
            return keys;
        });
    }
    isAccountValid() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const account = this.rpc && (yield this.rpc.get_account(this.accountName));
                const actualKeys = this.extractAccountKeys(account);
                const authorizationKeys = yield this.getKeys();
                const legacyAuthorizationKeys = authorizationKeys.map((key) => this.convertToLegacyPubKey(key));
                return actualKeys.filter((key) => {
                    return legacyAuthorizationKeys.indexOf(key) !== -1;
                }).length > 0;
            }
            catch (e) {
                const message = `Account validation failed for account ${this.accountName}.`;
                const type = universal_authenticator_library_1.UALErrorType.Validation;
                const cause = e;
                throw new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
            }
        });
    }
    extractAccountKeys(account) {
        const keySubsets = account.permissions.map((permission) => permission.required_auth.keys.map((key) => key.key));
        let keys = [];
        for (const keySubset of keySubsets) {
            keys = keys.concat(keySubset);
        }
        return keys;
    }
    convertToLegacyPubKey(publicKey) {
        const K1_PREFIX = 'PUB_K1_';
        if (publicKey.substr(0, K1_PREFIX.length) !== K1_PREFIX) {
            return publicKey;
        }
        const nonPrefixPublicKey = publicKey.substr(K1_PREFIX.length);
        const bytesWithChecksum = bs58.decode(nonPrefixPublicKey);
        const bytes = bytesWithChecksum.slice(0, bytesWithChecksum.length - 4);
        const suffixBytes = Buffer.from(RIPEMD160(bytes)).slice(0, 4);
        const binaryPublicKey = Buffer.from([...bytes, ...suffixBytes]);
        return `EOS${bs58.encode(binaryPublicKey)}`;
    }
    throwIfNotInitialized() {
        if (!this.api) {
            const message = 'Account Initialization failed.';
            const type = universal_authenticator_library_1.UALErrorType.Initialization;
            const cause = new Error('Please initialize `EOSIOAuthUser` before using');
            throw new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
        }
    }
}
exports.EOSIOAuthUser = EOSIOAuthUser;
